export default "__VITE_ASSET__ddFM4Hyb__"